import styled from "styled-components";

export const StyledPdfPage = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  height: 100vh;
  position: relative;
  h1 {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 15vh;
  }
  footer {
    font-size: 12px;
    text-align: center;
    position: absolute;
    bottom: 0;
  }
  div.body-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
`;

export const StyledPdfHeader = styled.div``;
